export default [
  {
    title: 'Benvinguda',
    element: '.none',
    text: 'Benvingut a {{wlName}}, la seva plataforma mèdica d\'intercanvi d\'imatges. En aquesta visita l\'ajudarem a començar.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: 'Resultats mèdics',
    element: '.icons-layout',
    text: 'Aquí podrà veure totes les carpetes, documents i proves mèdiques que li hagin compartit.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: 'Encara no hi ha resultats',
    element: '.empty-folder',
    text: 'Sembla que encara no han pujat els seus resultats. Aquest procés pot trigar diversos dies.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  },
  {
    title: 'Veure els arxius',
    element: '.icon-wrapper-file',
    text: 'Pot fer <strong>doble clic</strong> per entrar en carpetes o obrir arxius.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/desktop/ca-ES/guestTour.js